import React, { lazy, Suspense } from "react";
import { Spin } from "antd";

const FallbackUI = (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignitems: "center",
      height: "100vh",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
      }}
    >
      <Spin size={"large"} />
    </div>
  </div>
); // Replace with your custom loading message

const loadable = (importFunc, {} = { fallback: null }) => {
  const LazyComponent = lazy(importFunc);

  return props => (
    <Suspense fallback={FallbackUI}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
